module.exports = [{
      plugin: require('/zeit/55d8a1fb/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/zeit/55d8a1fb/src/components/layout.js"}},
    }]
